import { Check } from 'lucide-react';

export default function ProgressCard({
  icon: Icon,
  label,
  checked,
  total,
  iconColor = 'text-accent',
  progressColor = 'bg-accent',
}) {
  const percentage = total > 0 ? (checked / total) * 100 : 0;
  const isComplete = checked === total && total > 0;

  return (
    <div className={`
      group relative overflow-hidden
      bg-gradient-to-br from-surface-card to-surface-elevated
      rounded-xl p-3
      border border-border
      shadow-[var(--shadow-soft)]
      transition-all duration-300
      hover:border-border-strong hover:shadow-[var(--shadow-card)]
      ${isComplete ? 'ring-1 ring-success/20' : ''}
    `}>
      {/* Header */}
      <div className="flex items-center justify-between mb-1">
        <div className="flex items-center gap-1.5">
          <div className={`
            p-1 rounded-md
            ${isComplete ? 'bg-success-light' : progressColor.includes('weekly') ? 'bg-weekly-light' : progressColor.includes('monthly') ? 'bg-monthly-light' : 'bg-accent-muted'}
          `}>
            {isComplete ? (
              <Check size={12} className="text-success" strokeWidth={2.5} />
            ) : (
              <Icon size={12} className={iconColor} />
            )}
          </div>
          <span className="text-[11px] font-semibold text-text-primary">{label}</span>
          {isComplete && (
            <span className="text-[9px] text-success font-medium">Done!</span>
          )}
        </div>

        {/* Counter */}
        <div className={`text-base font-bold tracking-tight ${isComplete ? 'text-success' : 'text-text-primary'}`}>
          {checked}
          <span className="text-text-tertiary text-xs font-normal">/{total}</span>
        </div>
      </div>

      {/* Progress Bar */}
      <div className="relative">
        <div className="h-1 bg-surface-hover rounded-full overflow-hidden">
          <div
            className={`h-full rounded-full transition-all duration-500 ease-out ${
              isComplete ? 'bg-gradient-to-r from-success to-emerald-400' :
              progressColor.includes('weekly') ? 'bg-gradient-to-r from-weekly to-indigo-400' :
              progressColor.includes('monthly') ? 'bg-gradient-to-r from-monthly to-purple-400' :
              'bg-gradient-to-r from-accent to-accent-bright'
            }`}
            style={{ width: `${percentage}%` }}
          />
        </div>
      </div>
    </div>
  );
}
